import { login, logout } from "@/api/api";
import { getNavbarData } from "../actions";

import { getToken, setToken, removeToken } from "@/utils/auth";

const state = {
  token: getToken(),
  id: window.sessionStorage.getItem("userId") || "", //用户ID
  userName: window.sessionStorage.getItem("userName") || "",
  userAllData: window.sessionStorage.getItem("userInfo")
    ? JSON.parse(window.sessionStorage.getItem("userInfo"))
    : {} //用户所有数据
};

const mutations = {
  SET_USER_INFO: (state, userInfo) => {
    state.userAllData = userInfo;
    state.id = "";
    state.userName = "";
    if (userInfo) {
      state.id = userInfo.user_id;
      state.userName = userInfo.user_name;
    }
  },

  SET_TOKEN: (state, token) => {
    state.token = token;
  },
  SET_NAME: (state, name) => {
    state.userName = name;
  }
};

const actions = {
  /**
   * 登录
   */
  login({ commit }, userInfo) {
    return new Promise((resolve, reject) => {
      login(userInfo)
        .then(res => {
          const data = res.data;
          setToken(data.token); //存储token
          setUserInfo(commit, data.user); //存储用户信息
          commit("SET_TOKEN", data.token);
          commit("app/SET_INDEX_POP_STATE", 0, { root: true });

          resolve(data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  /**
   * 退出登录
   */
  logout({ commit }) {
    return new Promise(async resolve => {
      try {
        // await logout();
        commit("SET_TOKEN", "");
        commit("SET_USER_INFO", "");
        clearLocalUserInfo(); //删除本地用户信息
        resolve();
      } catch (error) {
        console.log(error);
      }
    });
  },

  /**
   * 移除token
   */
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit("SET_TOKEN", "");
      removeToken();
      resolve();
    });
  },
  setUserAllData({ commit }, userInfo) {
    return new Promise(resolve => {
      setUserInfo(commit, userInfo); //更新用户信息
      resolve();
    });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};

export const setUserInfo = (commit, userData) => {
  commit("SET_USER_INFO", userData); //设置用户数据
  setLocalUserInfo(userData); //存储用户信息
};

//清除本地数据
const clearLocalUserInfo = () => {
  removeToken();
  window.sessionStorage.removeItem("userInfo");
  window.sessionStorage.removeItem("userName");
  window.sessionStorage.clear();
};

//存储本地数据
const setLocalUserInfo = userData => {
  window.sessionStorage.setItem("userInfo", JSON.stringify(userData));
  window.sessionStorage.setItem("userName", userData.user_name);
};



// WEBPACK FOOTER //
// ./src/vuex/modules/user.js